module.exports = __webpack_public_path__ + "static/media/yellowHandRaise.98498322.svg";